import React from 'react';
import { observer } from 'mobx-react';
import { SecondaryNavigation } from '@/shared/navigation';
import { Container } from './sidebar.sc';

export const Sidebar = observer(() => {
  return (
    <Container data-test-automation-id="sidebar">
      <SecondaryNavigation />
    </Container>
  );
});
